import { render, staticRenderFns } from "./ChatItemRight.vue?vue&type=template&id=3ebf2f99&scoped=true&"
import script from "./ChatItemRight.vue?vue&type=script&lang=js&"
export * from "./ChatItemRight.vue?vue&type=script&lang=js&"
import style0 from "./ChatItemRight.vue?vue&type=style&index=0&id=3ebf2f99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebf2f99",
  null
  
)

export default component.exports